export default __webpack_public_path__ + "static/media/default_empty_logo.82c93c2f.svg";